import Vue from "vue";
import Router from "vue-router";
import routerMap from "./router.js";
import store from "@/stores";
import DTODBA21 from "@/service/DTODBA21";
import CathayAxios from "@/assets/plugins/cathay.Axios/cathayAxios";

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: process.env.NODE_ENV === "development" ? "/health/" : "/ODBA/health/",
  routes: routerMap.routes
});
router.beforeEach((to, from, next) => {
  //部分連結因推播已發出,頁面已下架,也需做踢回新首頁的動作
  const oldPageAry = ["ODBAF220", "ODBAF403", "ODBAF260", "ODBAF265"];
  //2023-06-30跳進新首頁
  if (oldPageAry.includes(to.name)) {
    if (from.query.invite_code) {
      window.location.href = `${process.env.VUE_APP_ODBR_HOST}fitback/index?invite_code=${from.query.invite_code}`;
      console.log("from.query.invite_code",from.query.invite_code)
      console.log('url',`${process.env.VUE_APP_ODBR_HOST}fitback/index?invite_code=${from.query.invite_code}`)
      return;
    }
    console.log(from)
    const routerPath = from.fullPath
    if(routerPath.indexOf('&amp')>-1){
      let newQueryArr = Object.values(from.query)
      let newQueryRouter = newQueryArr[0].substring(1);
      let newQueryTask = newQueryArr[1]
      console.log(newQueryRouter,newQueryTask)
      window.location.href =  `${process.env.VUE_APP_ODBR_HOST}${newQueryRouter}?task_no=${newQueryTask}`;
      return 
    }
    const queryParam = localStorage.getItem("queryParam");
    if (queryParam) {
      localStorage.removeItem("queryParam");
      window.location.href =
        `${process.env.VUE_APP_ODBR_HOST}fitback/index?` + queryParam;
      return;
    }
    //把原本的參數都帶到新首頁
    window.location.href =
      `${process.env.VUE_APP_ODBR_HOST}fitback/index` +
      to.fullPath.replace(to.path, "");
    return;
  }

  if ((to.name && !from.name) || to.params.pass === "Y") {
    next();
  } else if (from.name) {
    const params = to.params;
    params.fromName = from.name;
    params.pass = "Y";
    router.push({
      name: to.name,
      params,
      query: to.query
    });
  }

  //如果來源是null,則表示在login導頁中,不用紀錄log
  if (!from.name) {
    return;
  }

  store.dispatch("insertLog", {
    client_device: isMobile(),
    curr_page: from.name,
    next_page: to.name
  });
  //延後timeout時間
  const img = $("<img>").attr("src", process.env.VUE_APP_OC_RESOURCE_PATH);
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

function isMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return "Mobile";
  }
  return "Desktop";
}
export default router;
